import React from 'react';
import './Stepper.css';

export const Stepper = ({ currentStep }) => {
  const steps = [
    { label: "Delivery & Shipping", step: 1 },
    { label: "Billing & Payment", step: 2 },
    { label: "Review Order", step: 3 }
  ];

  return (
    <div className="checkout-status-bar" id="formStartsAt">
      {steps.map((item) => {
        const isCompleted = item.step < currentStep;
        const isActive = item.step === currentStep;

        return (
          <div
            key={item.step}
            className={`checkout-status ${
              isCompleted ? 'checkout-status-done' : isActive ? 'checkout-status-on' : ''
            }`}
          >
            <div className="status-number">{item.step}</div>
            {item.label}
          </div>
        );
      })}
    </div>
  );
};